export default __webpack_public_path__ + "static/media/logo-app-1.5aa0f3d3.svg";